<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['query']);

const queryText = ref('');

const handleSubmit = () => {
  if (queryText.value.trim()) {
    emit('query', queryText.value.trim());
    queryText.value = ''; // Clear input after submit
  }
};

const handleKeydown = event => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    handleSubmit();
  }
};
</script>

<template>
  <div>
    <label
      for="global-query"
      class="block text-xs font-medium text-n-slate-11 mb-2"
    >
      {{ $t('AGENTS_SIDECAR.QUERY.LABEL') }}
    </label>
    <div class="relative">
      <input
        id="global-query"
        v-model="queryText"
        type="text"
        :placeholder="$t('AGENTS_SIDECAR.QUERY.PLACEHOLDER')"
        class="w-full px-3 py-2.5 pr-12 text-sm bg-n-solid-2 border border-n-weak rounded-lg text-n-slate-12 placeholder:text-n-slate-9 focus:outline-none focus:ring-2 focus:ring-n-brand focus:border-transparent"
        :disabled="isLoading"
        @keydown="handleKeydown"
      />
      <Button
        ghost
        slate
        xs
        class="absolute right-1.5 top-1/2 -translate-y-1/2"
        :disabled="!queryText.trim() || isLoading"
        @click="handleSubmit"
      >
        <span v-if="isLoading" class="i-lucide-loader-2 animate-spin" />
        <span v-else class="i-lucide-search" />
      </Button>
    </div>
    <p class="mt-1.5 text-xs text-n-slate-9">
      {{ $t('AGENTS_SIDECAR.QUERY.HINT') }}
    </p>
  </div>
</template>
